import React, { useState } from "react";
/** @jsxImportSource @emotion/react */
import "twin.macro";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { Divider, Modal } from "antd";
import { Wrapper } from "./component";
import { PageLoading } from "../Loading/Loading";
import { useMediaQuery } from "react-responsive";
import { useFetchSelectedCartItems } from "../../redux/api/cartAPI";
import { isEmpty } from "../../lib/helpers/helpers";
import EmptyData from "../EmptyData/EmptyData";
import CartItem from "../CartItem/CartItem";
import { AppButton, ButtonLightPink } from "../../lib/styles/styleLibrary";
import CurrencyFormat from "react-currency-format";
import { useEffect } from "react";

const Cart = ({
	showModal,
	setShowModal = () => {
		return null;
	},
	weddingID,
	email,
}) => {
	const isMobile = useMediaQuery({ maxWidth: 1217 });
	const { data: cartData, isLoading: cartLoading } =
		useFetchSelectedCartItems({
			email: email,
			weddingId: weddingID,
		});

	const [singlecartData, setsinglecartData] = useState([]);
	const [vat, setvat] = useState("");

	useEffect(() => {
		if (isEmpty(cartData?.cart?.cart_items)) {
			setsinglecartData([]);
			return;
		}
		setsinglecartData(cartData?.cart?.cart_items);
		setvat(0.075 * cartData?.total_price);
	}, [cartData]);

	return (
		<Wrapper>
			<Modal
				footer=""
				visible={showModal}
				centered
				width={isMobile ? "100%" : "75%"}
				closable={false}
				maskClosable={false}>
				<div
					tw="h-8 w-8 px-2 py-2 bg-gray-100! rounded-full hover:(cursor-pointer border-2 border-solid border-purple-800) flex items-center justify-center"
					onClick={() => setShowModal(false)}>
					<ArrowLeftOutlined
						tw="hover:(text-purple-800 transform scale-125)"
						style={{ zIndex: 50000000 }}
					/>
				</div>

				<h3 tw="font-bold text-center text-lg opacity-90 leading-8 tracking-wide absolute top-6 right-0 left-0">
					My Cart
				</h3>
				<div tw="bg-gray-100 rounded mt-4">
					<h3 tw="p-4 font-bold text-sm leading-8 tracking-wide">
						<span tw="text-appPinkSaturated">
							{!isEmpty(singlecartData)
								? singlecartData?.length
								: "0"}{" "}
						</span>
						Items Available
					</h3>

					<div style={{ height: "60vh", overflow: "auto" }}>
						<div tw="p-8 pt-0! flex flex-row flex-wrap gap-8 mb-4!">
							{isEmpty(singlecartData) ? (
								<div tw="h-1/2! w-full flex items-center justify-center">
									<EmptyData description="No item in cart" />
								</div>
							) : (
								singlecartData?.map((cartitem, j) => {
									console.log("cartitem", cartitem);
									return <CartItem key={j} item={cartitem} />;
								})
							)}
						</div>
					</div>
				</div>
				<div tw="bg-white rounded p-8">
					<div tw="pt-0! flex flex-row flex-wrap gap-4 justify-between items-center mb-4!">
						<h3 tw="font-bold text-sm leading-8 tracking-wide">
							Sub total
						</h3>
						<h3 tw="font-bold text-sm leading-8 tracking-wide">
							<h3 tw="font-bold text-sm leading-8 tracking-wide">
								<CurrencyFormat
									value={cartData?.total_price}
									allowNegative={false}
									displayType={"text"}
									thousandSeparator={true}
									placeholder={"00.00"}
									type="tel"
									decimalScale={2}
									fixedDecimalScale={true}
									prefix={"₦"}
								/>
							</h3>
						</h3>
					</div>
					<Divider tw="mt-2! mb-2!" />
					<div tw="pt-0! flex flex-row flex-wrap gap-4 justify-between items-center mb-4!">
						<h3 tw="font-bold text-sm leading-8 tracking-wide">
							Tax(7.5%)
						</h3>
						<h3 tw="font-bold text-sm leading-8 tracking-wide">
							<h3 tw="font-bold text-sm leading-8 tracking-wide">
								<CurrencyFormat
									value={vat}
									allowNegative={false}
									displayType={"text"}
									thousandSeparator={true}
									placeholder={"00.00"}
									type="tel"
									decimalScale={2}
									fixedDecimalScale={true}
									prefix={"₦"}
								/>
							</h3>
						</h3>
					</div>
					<Divider tw="mt-2! mb-2!" />
					<div tw="pt-0! flex flex-row flex-wrap gap-4 justify-between items-center mb-4!">
						<h3 tw="font-bold text-sm leading-8 tracking-wide">
							Total:
						</h3>
						<h3 tw="font-bold text-sm leading-8 tracking-wide">
							<CurrencyFormat
								value={cartData?.total_price + vat}
								allowNegative={false}
								displayType={"text"}
								thousandSeparator={true}
								placeholder={"00.00"}
								type="tel"
								decimalScale={2}
								fixedDecimalScale={true}
								prefix={"₦"}
							/>
						</h3>
					</div>
					<div tw="mt-2! mb-2! text-center text-appPink">
						Charges may apply.
					</div>

					<div tw="pt-4! flex flex-row flex-wrap md:flex-nowrap gap-4 justify-between items-center mb-4!">
						<ButtonLightPink tw="font-bold text-sm leading-8 tracking-wide w-full h-12!">
							Pay with Wallet
						</ButtonLightPink>
						<AppButton tw="font-bold text-sm leading-8 tracking-wide">
							Pay with Card
						</AppButton>
					</div>
				</div>
				{cartLoading && (
					<div style={{ height: "50vh" }}>
						<PageLoading />
					</div>
				)}
			</Modal>
		</Wrapper>
	);
};

export default Cart;
